var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiAssignment = function SvgAiAssignment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 23"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 9.333,
    x: 13.833,
    y: 0.667,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2.667,
    x: 9,
    y: 11.333,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.667,
    height: 2.667,
    x: 9,
    y: 16,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M11.667 9.333h10v8h-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M24.377 11.724a.29.29 0 0 1 .268.185.31.31 0 0 1-.063.328l-3.543 3.675a.28.28 0 0 1-.316.065.3.3 0 0 1-.179-.277v-3.675c0-.167.13-.301.29-.301zm-3.253 3.25 2.553-2.649h-2.553zM23.352 5.312a.926.926 0 0 0 0-1.275l-.486-.504a.85.85 0 0 0-1.23 0l-1.1 1.142 1.715 1.78zm-.896 1.78a.283.283 0 0 1-.41 0l-2.125-2.205a.31.31 0 0 1 0-.425l1.306-1.355a1.413 1.413 0 0 1 2.05 0l.485.504a1.544 1.544 0 0 1 0 2.127z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M22.456 6.667a.31.31 0 0 1 0 .425l-4.251 4.41a.3.3 0 0 1-.134.08l-2.834.745a.28.28 0 0 1-.276-.078.31.31 0 0 1-.076-.286l.708-2.951a.3.3 0 0 1 .076-.14l4.252-4.41a.283.283 0 0 1 .41 0zm-6.32 2.57-.572 2.384 2.287-.603 3.99-4.138-1.715-1.78z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M16.583 3.639c.16 0 .29.134.29.3 0 .167-.13.301-.29.301h-4.67V15.4h8.921c.16 0 .29.135.29.3 0 .167-.13.301-.29.301h-9.21a.295.295 0 0 1-.29-.3V3.94c0-.167.13-.301.29-.301zM24.087 12.024v-2.94c0-.166.13-.3.29-.3s.29.134.29.3v2.94c0 .166-.13.301-.29.301a.295.295 0 0 1-.29-.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m34.5 0 .99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99z"
  })));
};
export { SvgAiAssignment as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-assignment-6103776d2ac4afc219b5ad0e3363e8d5.svg";